import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Switch,Router } from 'react-router'
import { Route } from 'react-router-dom'
import history from './dependencies/history'
import configureStore from './store/configureStore'
import bootstrap from 'bootstrap'
import PublicIndex from './components/pages/public/PublicIndex'
import PageNotFound from './components/pages/PageNotFound'
import HomePage from './components/pages/HomePage'
import HowItWorks from './components/pages/HowItWorks'
import Pricing from './components/pages/Pricing'
import HelpPage from './components/pages/HelpPage'
import FaqRecruiter from './components/pages/FaqRecruiter'
import PartnersPage from './components/pages/PartnersPage'
import TeamPage from './components/pages/TeamPage'
import HomePageVideo from './components/pages/HomePageVideo'
import ArticlesCampuses from './components/pages/ArticlesCampuses'
import ArticlesProfessionals from './components/pages/ArticlesProfessionals'
import ArticlesTechnicalHiring from './components/pages/ArticlesTechnicalHiring'
import ArticlesRemote from './components/pages/ArticlesRemote'
import ArticlesGlobalHiring from './components/pages/ArticlesGlobalHiring'
import ArticlesPartners from './components/pages/ArticlesPartners'
import FrequentlyAskedQuestions from './components/pages/FrequentlyAskedQuestion'
import TermOfServices from './components/pages/TermOfServices'
import PrivacyPolicy from './components/pages/PrivacyPolicy'
import CompanyList from './components/companies/pages/CompanyList'
import UserRegisterWizardFormContainer from './components/pages/UserRegisterWizardFormContainer'
import CompanyJobDetail from './components/companies/pages/CompanyJobDetail'
import CompanyJobDetailByCode from './components/companies/pages/CompanyJobDetailByCode'
import CompanyJobDetailMobile from './components/companies/pages/CompanyJobDetailMobile'
import MultiUploadDoc from './components/companies/pages/MultiUploadDoc'
import FinishUpload from './components/companies/pages/FinishUpload'
import UploadExpired from './components/companies/pages/UploadExpired'
import CandidateVideo from './components/candidates/pages/CandidateVideo'
import InviteCheckInterviewCode from './components/invites/pages/InviteCheckInterviewCode'
import InviteInterviewsWithCode from './components/invites/pages/InviteInterviewsWithCode'
import InviteCheckInterviewCodeBcg from './components/invites/pages/InviteCheckInterviewCodeBcg'
import LoaderNew from './components/partials/LoaderNew'

import * as serviceWorker from './serviceWorker';

import './styles/sass/public/bootstrap-custom.scss'
import 'font-awesome/css/font-awesome.css'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import 'react-select/dist/react-select.css'
import 'nprogress/nprogress.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './styles/sass/public/style.scss'
import './styles/sass/main.scss'
import './styles/sass/style.scss'


const store = configureStore()

if (process.env.REACT_APP_API_HOST) {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
  }
   
const publicIndexTarget = document.getElementById("job-landing-page")

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <PublicIndex>
            <Switch>
                            <Route exact path='/' component={HomePage} />
                            <Route exact path='/homepage-video' component={HomePageVideo} />
                            <Route exact path='/about' component={TeamPage} />
                            <Route exact path='/partners' component={PartnersPage} />
                            <Route exact path='/how-it-works' component={HowItWorks} />
                            <Route exact path='/pricing' component={Pricing} />
                            <Route exact path='/help' component={HelpPage} />
                            <Route exact path='/help/faq' component={FaqRecruiter} />
                            <Route exact path='/faq' component={FrequentlyAskedQuestions} />
                            <Route exact path='/faq/:langId' component={FrequentlyAskedQuestions} />
                            <Route exact path='/termsofservice' component={TermOfServices} />
                            <Route exact path='/privacypolicy' component={PrivacyPolicy} />
                            <Route exact path='/astronaut-for/campuses' component={ArticlesCampuses} />
                            <Route exact path='/astronaut-for/professionals' component={ArticlesProfessionals} />
                            <Route exact path='/astronaut-for/technical-hiring' component={ArticlesTechnicalHiring} />
                            <Route exact path='/astronaut-for/remote-and-field-hiring' component={ArticlesRemote} />
                            <Route exact path='/astronaut-for/global-hiring' component={ArticlesGlobalHiring} />
                            <Route exact path='/astronaut-for/partner-via-api' component={ArticlesPartners} />
                            <Route exact path='/register' component={UserRegisterWizardFormContainer} />
                            <Route exact path='/RPXpAa5YKyuJvenXfTyCTGyliY1hQU/companies' component={CompanyList} />
                            <Route exact path='/RPXpAa5YKyuJvenXfTyCTGyliY1hQU/companies/:companySlug' component={CompanyJobDetail} />
                            <Route exact path='/mobile/companies/:companySlug' component={CompanyJobDetailMobile} />
                            <Route path='/RPXpAa5YKyuJvenXfTyCTGyliY1hQU/companies/:companySlug/jobs/:jobSlugs' component={CompanyJobDetail} />
                            <Route path='/mobile/companies/:companySlug/jobs/:jobSlugs' component={CompanyJobDetailMobile} />
                            <Route path='/RPXpAa5YKyuJvenXfTyCTGyliY1hQU/candidates/video/:hashVideoId' component={CandidateVideo} />
                            <Route path='/ldes9qVhgzBBurVGVrZlaWaVZ6PRA5/:interviewCode' component={InviteCheckInterviewCode} />
                            <Route path='/code-bcg/:interviewCode' component={InviteCheckInterviewCodeBcg} />
                            <Route path='/interviews/:interviewCode' component={InviteInterviewsWithCode} />
                            <Route path='/p/:code' component={CompanyJobDetailByCode} />
                            <Route path='/multiupload/candidates/:hashCandidateId' component={MultiUploadDoc} />
                            <Route path='/multiupload/finish/candidates/:hashCandidateId' component={FinishUpload} />
                            <Route path='/multiupload/expired/candidates/:hashCandidateId' component={UploadExpired}/>
                            <Route  component={PageNotFound} />
                </Switch>
                    </PublicIndex>
        </Router>
    </Provider>,
publicIndexTarget
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
